import { exhaustAll } from './exhaustAll';
export var exhaust = exhaustAll;